import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import '../../CSS/Global.css';
import { Document, Page, Text, View, StyleSheet, Image, Link, pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import logoImgText from '../../Img/100BILLION_TECH_name.png';
import logoImg from '../../Img/100BILLION_ICON.png';
import Swal from 'sweetalert2';
import { parseDocument } from 'htmlparser2';
import { DomUtils } from 'htmlparser2';
import dayjs from "dayjs";


const Invoice = () => {
    const { isSidebarOpen } = useSidebar();
    const navigate = useNavigate();
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [isImportOpen, setImportOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [invoices, setInvoices] = useState([]);
    const [downloadingId, setDownloadingId] = useState(null);
    const [downloadedId, setDownloadedId] = useState(null);
    const url = process.env.REACT_APP_LINK
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 10;

    const safeDate = (dateStr) => {
        try {
            if (!dateStr || dateStr === "0000-00-00") return "N/A";

            const parsedDate = new Date(dateStr);

            // Check if it's a valid date
            if (isNaN(parsedDate.getTime())) return "N/A";

            return parsedDate.toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        } catch {
            return "N/A";
        }
    };


    const invoicesForSummary = Array.isArray(invoices)
        ? invoices.filter(inv => inv.dpstatus !== "Draft")
        : [];

    const totalReceivablesPending = invoicesForSummary.reduce((acc, invoice) => acc + (parseFloat(invoice.pending) || 0), 0);

    const today = new Date().toISOString().split("T")[0];

    // const dueTodayPendingTotal = invoices.reduce((acc, invoice) => {
    //     const dueDate = new Date(invoice.due_date).toISOString().split("T")[0];
    //     return dueDate === today ? acc + (parseFloat(invoice.pending) || 0) : acc;
    // }, 0);
    const dueTodayPendingTotal = invoices.reduce((acc, invoice) => {
        if (!invoice.due_date || invoice.due_date === "0000-00-00") return acc;

        const dueDateObj = new Date(invoice.due_date);
        if (isNaN(dueDateObj.getTime())) return acc;

        const dueDate = dueDateObj.toISOString().split("T")[0];
        return dueDate === today ? acc + (parseFloat(invoice.pending) || 0) : acc;
    }, 0);


    const handleEdit = (invoice) => {
        navigate('/new-invoice', { state: { invoice } });
    };

    // const getStatus = (invoice) => {
    //     const today = new Date().toISOString().split("T")[0];
    //     const dueDate = invoice.due_date;
    //     const pending = parseFloat(invoice.pending) || 0;

    //     if (pending === 0) return { label: "Paid", color: "green" };
    //     if (dueDate < today) return { label: "Overdue", color: "red" };
    //     return { label: "Pending", color: "gray" };
    // };

    const getStatus = (invoice) => {
        const today = new Date().toISOString().split("T")[0];
        const dueDate = invoice.due_date;

        const pending = parseFloat(invoice.pending) || 0;

        if (pending === 0) return { label: "Paid", color: "green" };

        if (!dueDate || dueDate === "0000-00-00") return { label: "Pending", color: "gray" };

        try {
            if (new Date(dueDate).toISOString().split("T")[0] < today) {
                return { label: "Overdue", color: "red" };
            }
        } catch {
            return { label: "Pending", color: "gray" };
        }

        return { label: "Pending", color: "gray" };
    };

    const overduePendingTotal = invoices.reduce((acc, invoice) => {
        if (invoice.dpstatus === "Draft") return acc;
        const { label } = getStatus(invoice);
        return label === "Overdue" ? acc + (parseFloat(invoice.pending) || 0) : acc;
    }, 0);

    const payableWithin30DaysTotal = invoices.reduce((acc, invoice) => {
        if (invoice.dpstatus === "Draft") return acc;
        const dueDate = new Date(invoice.due_date);
        const today = new Date();
        const diffInDays = (dueDate - today) / (1000 * 60 * 60 * 24);

        if (diffInDays > 0 && diffInDays <= 30) {
            return acc + (parseFloat(invoice.pending) || 0);
        }
        return acc;
    }, 0);

    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const res = await fetch(`${url}/newinvoice/all/${isLoggedIn.user_id}`);
                const data = await res.json();
                console.log(data)
                if (Array.isArray(data)) {
                    const sortedInvoices = data.sort((a, b) => a.order_number - b.order_number).reverse();
                    console.log(sortedInvoices)
                    setInvoices(sortedInvoices);
                } else {
                    setInvoices([]);
                    console.error("Fetched data is not an array:", data);
                }
            } catch (error) {
                console.error("Failed to fetch invoices:", error);
                setInvoices([]);
            }
        };

        fetchInvoices();
    }, []);


    // Toggle the dropdown list
    const toggleDropdown = () => {
        setDropdownOpen(!isDropdownOpen);
    };

    // Toggle the import list
    const toggleImport = () => {
        setImportOpen(!isImportOpen);
    };

    // Handle search input change
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredInvoices = invoices.filter((invoice) => {
        const search = searchQuery.toLowerCase();
        const status = getStatus(invoice).label;
        const createdBy = invoice.created_by?.toLowerCase() || "import";

        const matchesSearch = (
            invoice.customer_name?.toLowerCase().includes(search) ||
            invoice.invoice_number?.toLowerCase().includes(search) ||
            invoice.order_number?.toString().includes(search) ||
            invoice.invoice_date?.toLowerCase().includes(search) ||
            invoice.due_date?.toLowerCase().includes(search)
        );

        if (!matchesSearch) return false;

        switch (selectedFilter) {
            case "Active invoice":
                return status === "Pending";
            case "Paid invoice":
                return status === "Paid";
            case "Overdue invoice":
                return status === "Overdue";

            // ✅ Show only admin-submitted invoices (not imported)
            case "My invoice":
                return createdBy === "admin";
            case "My Active invoice":
                return createdBy === "admin" && status === "Pending";
            case "My Paid invoice":
                return createdBy === "admin" && status === "Paid";
            case "My Overdue invoice":
                return createdBy === "admin" && status === "Overdue";

            case "All invoice":
            default:
                return true;
        }
    });

    const SkeletonLoader = () => {
        return (
            <div>
                {Array(10)
                    .fill("")
                    .map((_, index) => (
                        <div className="skeleton-row" key={index}>
                            <div className="skeleton"></div>
                            <div className="skeleton"></div>
                            <div className="skeleton"></div>
                            <div className="skeleton"></div>
                            <div className="skeleton"></div>
                        </div>
                    ))}
            </div>
        );
    };

    const handleRefresh = () => {
        setLoading(true); // Start skeleton loader
        setTimeout(() => {
            setLoading(false); // End skeleton loader after data "refresh"
        }, 1000); // Simulate API refresh delay (2 seconds)
    };

    const toBase64 = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const indexOfLastCustomer = currentPage * entriesPerPage;
    const indexOfFirstCustomer = indexOfLastCustomer - entriesPerPage;
    const currentInvoices = filteredInvoices.slice(indexOfFirstCustomer, indexOfLastCustomer);
    const totalPages = Math.ceil(filteredInvoices.length / entriesPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const downloadInvoicePDF = async (invoice) => {
        const orderId = invoice.order_number;
        setDownloadingId(orderId);
        setDownloadedId(null);

        try {
            // Fetch user profile
            const profileRes = await fetch(`${url}/auth/singleuser/${isLoggedIn.user_id}`);
            const res = await profileRes.json();
            const profileData = res;

            // Convert logo to base64 (with fallback)
            let base64Logo = null;
            if (profileData?.profile) {
                const imageUrl = `${url}/${profileData.profile}`;
                try {
                    base64Logo = await toBase64(imageUrl);
                } catch (error) {
                    console.warn("Logo conversion failed:", error);
                    base64Logo = "https://100billiontech.com/static/media/100BILLION_TECH_name.aad194ea6504959b3f99.png"; // optional
                }
            }
            console.log(invoice)
            const blob = await pdf(
                <InvoiceDocument invoice={invoice} profile={profileData} logoBase64={base64Logo} />
            ).toBlob();
            saveAs(blob, `Invoice_${invoice.invoice_number}.pdf`);

            setDownloadedId(orderId);
            setTimeout(() => setDownloadedId(null), 1200);
        } catch (err) {
            alert("Failed to download invoice");
            console.error("Download error:", err);
        } finally {
            setDownloadingId(null);
        }
    };

    // useEffect(() => {
    //     fetch(`${url}/`, {
    //         mode: "cors"
    //     })
    //         .then((res) => {
    //             console.log("Fetch success:", res.status);
    //             return res.blob();
    //         })
    //         .then((blob) => console.log("Blob:", blob))
    //         .catch((err) => console.error("Fetch failed:", err));
    // }, []);
    const handleDelete = async (customerId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${url}/newinvoice/${customerId}`, {
                        method: 'DELETE',
                    });
                    if (!response.ok) {
                        const err = await response.json();
                        throw new Error(err?.message || 'Failed to delete');
                    }

                    Swal.fire('Deleted!', 'Invoice has been deleted.', 'success');
                    setInvoices((prev) => prev.filter((item) => item.id !== customerId));
                } catch (error) {
                    console.error('Delete error:', error.message);
                    Swal.fire('Error!', `Failed to delete invoice. ${error.message}`, 'error');
                }
            }
        });
    };




    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="customers-header">
                    <div className="customer-dropdown">
                        <p className="dashboard-title" onClick={toggleDropdown}>
                            {selectedFilter}

                            All Invoices
                            <i className={`fa-solid fa-chevron-down ${isDropdownOpen ? 'rotate' : ''}`}></i>
                        </p>
                    </div>
                    <div className="custom-header-ul">
                        {isDropdownOpen && (
                            <div className="customer-dropdown-list">
                                {/* Search Bar */}
                                <div className="input-container">
                                    <i className="fas fa-search"></i>
                                    <input
                                        type="search"
                                        name="search"
                                        id="search"
                                        placeholder="Search here..."
                                        value={searchQuery}
                                        onChange={handleSearch}
                                    />
                                </div>

                                {/* Default Filters */}
                                <div className="customer-dropdown-list-default">
                                    <p className="default-filter">
                                        <i className="fa-solid fa-chevron-right"></i>
                                        Default Filters
                                    </p>
                                    <ul className="customer-list-ul">
                                        <li onClick={() => setSelectedFilter("All invoice")}>All invoice</li>
                                        <li onClick={() => setSelectedFilter("Active invoice")}>Active invoice</li>
                                        <li onClick={() => setSelectedFilter("Overdue invoice")}>Overdue invoice</li>

                                    </ul>
                                </div>

                                {/* Added by Me */}
                                <div className="customer-dropdown-list-added">
                                    <p className="default-filter">
                                        <i className="fa-solid fa-chevron-right"></i>
                                        Added by Me
                                    </p>
                                    <ul className="customer-list-ul">
                                        <li onClick={() => setSelectedFilter("My invoice")}>My invoice</li>
                                        <li onClick={() => setSelectedFilter("My Active invoice")}>My Active invoice</li>
                                        <li onClick={() => setSelectedFilter("My Overdue invoice")}>My Overdue invoice</li>
                                        <li onClick={() => setSelectedFilter("My Paid invoice")}>My Paid invoice</li>
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="customer-warning-new-hamburger-help">
                        <p className="customer-warning-text">
                            <span>
                                <i className="fa-solid fa-triangle-exclamation"></i> Update GST details
                            </span>{' '}
                            for 520 customers
                        </p>
                        <div className="customer-new">

                            <button onClick={() => navigate("/new-invoice")} className="oms-add-btn">
                                <i className="fa-solid fa-plus"></i> New
                            </button>

                        </div>
                        <div className="import-hamburger" onClick={toggleImport}>
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                        {isImportOpen && (
                            <div className="import-ul">
                                <ul>
                                    <li onClick={() => navigate('/invoice-import')}>
                                        {/* <Link to='/invoice-import'> */}
                                        <i className="fa-solid fa-file-arrow-down"></i> Import invoice
                                        {/* </Link> */}
                                    </li>
                                </ul>
                                <ul>
                                    <li onClick={() => navigate('/export')}>
                                        {/* <Link to='/export'> */}
                                        <i className="fa-solid fa-file-arrow-up"></i> Export invoice
                                        {/* </Link> */}
                                    </li>
                                </ul>
                                <ul>
                                    <li>
                                        <a
                                            href="/sample_invoice.xlsx"
                                            download
                                            style={{ textDecoration: "none" }}
                                        >
                                            <i className="fa-solid fa-file-arrow-down"></i> Download Sample
                                        </a>

                                    </li>
                                </ul>
                                <ul>
                                    <li onClick={handleRefresh}>
                                        <i className="fa-solid fa-rotate"></i> Refresh List
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>

                {/* payment summary */}
                <div className="payment-summary">
                    <p className="payment-head">
                        Payment Summary
                    </p>
                    <div className="payment-summary-details">
                        <div className="payment-summary-list list1">
                            <i className="fa-solid fa-arrow-down"></i>
                            <div className="details">
                                <p className="label">Total receivables pending</p>
                                <h3>Rs. {totalReceivablesPending.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</h3>
                            </div>
                        </div>

                        <div className="payment-summary-list list2">
                            <div className="payment">
                                <p className="label">Due as of today</p>
                                <h3>Rs. {Number(dueTodayPendingTotal).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</h3>

                            </div>

                            <div className="payment">
                                <p className="label">Payable within 30 days</p>
                                <h3>Rs. {payableWithin30DaysTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</h3>
                            </div>

                            <div className="payment">
                                <p className="label">Invoices past due</p>
                                <h3>Rs. {overduePendingTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</h3>
                            </div>

                            {/* <div className="payment">
                                <p className="label">Average payment cycle</p>
                                <h3>₹800.28</h3>
                            </div> */}
                        </div>
                    </div>
                </div>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className={`fa fa-search ${searchQuery ? 'hidden' : ''}`}></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>


                {/* invoice table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Order No.</th>
                                <th>Customer Name</th>
                                <th>Due Date</th>
                                <th>Amount</th>
                                <th>Balance Due</th>
                                <th>D/P</th>
                                <th>Status</th>
                                <th>Invoice</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="10"><SkeletonLoader /></td>
                                </tr>
                            ) : currentInvoices.length === 0 ? (
                                <tr>
                                    <td colSpan="10" style={{ textAlign: "center", padding: "20px", color: "#999" }}>
                                        No Invoice Available
                                    </td>
                                </tr>
                            ) : (

                                currentInvoices.map((invoice, index) => (
                                    <tr key={index}>
                                        <td>{safeDate(invoice.invoice_date)}</td>
                                        <td>#{invoice.order_number || "N/A"}</td>
                                        <td>{invoice.customer_name || "N/A"}</td>
                                        <td>{safeDate(invoice.due_date)}</td>


                                        <td>
                                            Rs. {typeof invoice.grand_total === "number"
                                                ? invoice.grand_total.toLocaleString("en-IN", { minimumFractionDigits: 2 })
                                                : "0.00"}
                                        </td>
                                        <td>
                                            Rs. {typeof invoice.pending === "number"
                                                ? invoice.pending.toLocaleString("en-IN", { minimumFractionDigits: 2 })
                                                : "0.00"}
                                        </td>
                                        <td>{invoice.dpstatus || "N/A"}</td>
                                        <td style={{ color: getStatus(invoice).color, fontWeight: "bold" }}>
                                            {getStatus(invoice).label || "Unknown"}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                            {downloadingId === invoice.order_number ? (
                                                <div className="circle-loader"></div>
                                            ) : downloadedId === invoice.order_number ? (
                                                <i className="fa-solid fa-circle-down downloaded-icon"></i>
                                            ) : (
                                                <span
                                                    onClick={() => downloadInvoicePDF(invoice)}
                                                    className="download-text"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    Download
                                                </span>
                                            )}
                                        </td>
                                        <td>
                                            <button onClick={() => handleEdit(invoice)}>
                                                <i className="fa-solid fa-pencil"></i>
                                            </button>
                                            <button
                                                onClick={() => handleDelete(invoice.id)}
                                                className="delete-btn"
                                                style={{ marginLeft: '8px' }}
                                            >
                                                <i className="fa-solid fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))

                            )}
                        </tbody>
                    </table>


                </div>
                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                    {[...Array(totalPages)].map((_, index) => (
                        <button key={index} onClick={() => paginate(index + 1)} className={currentPage === index + 1 ? 'active' : ''}>
                            {index + 1}
                        </button>
                    ))}
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
                </div>
            </div>
        </>
    );
};

export default Invoice;

export const renderNoteAsPDF = (html) => {
    const doc = parseDocument(html);
    const nodes = DomUtils.getChildren(doc);

    const renderNodes = (elements, depth = 0) => {
        return elements.map((node, idx) => {
            if (node.type === 'text') {
                return node.data;
            }

            if (node.name === 'br') {
                return <Text key={`br-${depth}-${idx}`}>{'\n'}</Text>;
            }

            if (node.name === 'p') {
                return (
                    <Text key={`p-${depth}-${idx}`} style={styles.paragraph}>
                        {renderNodes(DomUtils.getChildren(node), depth + 1)}
                    </Text>
                );
            }
            if (node.name === 'a') {
                const href = node.attribs?.href || "#";
                const linkText = DomUtils.getText(node); // 🔥 Plain text from inside <a>
                return (
                    <Link
                        key={`a-${depth}-${idx}`}
                        src={href.startsWith("http") ? href : `https://${href}`} // ensure it's clickable
                        style={{ color: 'blue', textDecoration: 'none' }} // removes underline
                    >
                        {linkText}
                    </Link>
                );
            }


            if (node.name === 'u') {
                return (
                    <Text key={`u-${depth}-${idx}`} style={{ textDecoration: 'underline' }}>
                        {renderNodes(DomUtils.getChildren(node), depth + 1)}
                    </Text>
                );
            }



            if (node.name === 'strong' || node.name === 'b') {
                return (
                    <Text key={`b-${depth}-${idx}`} style={{ fontWeight: 'bold' }}>
                        {renderNodes(DomUtils.getChildren(node), depth + 1)}
                    </Text>
                );
            }

            if (node.name === 'em' || node.name === 'i') {
                return (
                    <Text key={`i-${depth}-${idx}`} style={{ fontStyle: 'italic' }}>
                        {renderNodes(DomUtils.getChildren(node), depth + 1)}
                    </Text>
                );
            }

            if (node.name === 'ul') {
                return DomUtils.getChildren(node)
                    .filter(n => n.name === 'li')
                    .map((li, i) => (
                        <Text key={`ul-${depth}-${idx}-${i}`} style={styles.listItem}>
                            • {renderNodes(DomUtils.getChildren(li), depth + 1)}
                        </Text>
                    ));
            }

            if (node.name === 'ol') {
                return DomUtils.getChildren(node)
                    .filter(n => n.name === 'li')
                    .map((li, i) => (
                        <Text key={`ol-${depth}-${idx}-${i}`} style={styles.listItem}>
                            {`${i + 1}. ${renderNodes(DomUtils.getChildren(li), depth + 1)}`}
                        </Text>
                    ));
            }

            // fallback for unknown tags
            return renderNodes(DomUtils.getChildren(node), depth + 1);
        });
    };

    return renderNodes(nodes);
};



const styles = StyleSheet.create({
    summaryRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: 4,
        fontSize: 12,
        paddingHorizontal: 10
    },
    textLogo: {
        fontSize: 20,
        fontWeight: "bold",
        color: "#003366",
        padding: 4,
        backgroundColor: "#d1dffa",
        borderRadius: 4,
        textAlign: "center"
    },
    summaryLabel: {
        fontWeight: "bold",
        fontSize: 12
    },
    summaryValue: {
        fontSize: 12
    },
    page: { padding: 20, backgroundColor: "#f9f9f9", paddingBottom: 70, },
    header: {
        flexDirection: "row", justifyContent: "space-between", alignItems: "center",
        marginBottom: 12, padding: 8, borderBottomWidth: 1, borderBottomColor: "#ddd",
        backgroundColor: "#d1dffa", gap: "15px"
    },
    headerP: { fontSize: 12, color: "#444", marginTop: "5px" },
    flex: { flex: 1 },
    headerRight: { textAlign: "right" },
    displayLogo: { display: "flex", flexDirection: "row", alignItems: "center" },
    logo1: { width: 40, marginRight: 5, objectFit: "contain" },
    logo2: { width: 100, objectFit: "contain" },
    invoiceInfo: {
        flexDirection: "row", justifyContent: "space-between",
        fontSize: 14, marginBottom: 12, marginTop: 8
    },
    invoiceFlex: { flex: 1, maxWidth: "50%" },
    invoiceFlexHeading: { fontSize: 16, fontWeight: "bold", marginBottom: 5 },
    invoiceInfoText: { marginBottom: 3, fontSize: 14 },
    row: {
        flexDirection: "row", borderBottomWidth: 1,
        paddingVertical: 4, borderBottomColor: "#ddd",
        fontSize: 14, textAlign: "left"
    },
    cell: { flex: 1, textAlign: "center", fontSize: 12 },
    cellFlex2: { flex: 2, textAlign: "center", fontSize: 12 },
    invoiceTotal: {
        textAlign: "right", fontSize: 16, fontWeight: "bold",
        marginBottom: 12, marginTop: 8, color: "#111"
    },
    invoiceNotesHeading: { fontSize: 14, marginTop: 8, marginBottom: 6, fontWeight: "600" },
    invoiceNotesLi: { fontSize: 12, color: "#555" },
   pageFooter: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    paddingVertical: 10,
    // borderTopWidth: 1,
    // borderTopColor: '#ccc',
    alignItems: 'center',
    justifyContent: 'center',
    // backgroundColor: '#f9f9f9',
},
    footerPowered: {
        fontSize: 4,
        color: '#555',
        marginBottom: 2,
    },
    footerLogo: {
        width: 60,
        // height: 50,
        objectFit: 'contain'
    },
    paragraph: {
        fontSize: 12,
        marginBottom: 3,
        lineHeight: 1.1,
    },
    listItem: {
        fontSize: 12,
        marginLeft: 12,
        marginBottom: 2,
        lineHeight: 1.5,
    },


});

const InvoiceDocument = ({ invoice, profile, logoBase64 }) => {
    console.log(invoice);
    if (!invoice || !profile) {
        console.error("Invalid invoice or profile data");
        return;
    }
    const url = process.env.REACT_APP_LINK
    let items = [];
    try {
        items = Array.isArray(invoice.items)
            ? invoice.items
            : JSON.parse(invoice.items);
    } catch {
        items = [];
    }




    const totalAmount = invoice.grand_total;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.header}>
                    <View style={styles.flex}>
                        <View style={styles.displayLogo}>
                            {logoBase64 ? (
                                <Image src={logoBase64 || "https://100billiontech.com/static/media/100BILLION_TECH_name.aad194ea6504959b3f99.png"} style={styles.logo2} />
                            ) : (
                                <Text style={styles.textLogo}>
                                    {profile.orignal_logoname || "Your Company Name"}
                                </Text>
                            )}

                        </View>

                        <Text style={styles.headerP}>{profile.office_address || ""}</Text>
                    </View>
                    <View style={[styles.flex, styles.headerRight]}>
                        <Text style={styles.headerP}>Invoice Date: {invoice.invoice_date}</Text>
                        <Text style={styles.headerP}>Invoice #: {invoice.invoice_number}</Text>
                        <Text style={styles.headerP}>Order #: {invoice.order_number}</Text>
                        <Text style={styles.headerP}>Phone No.: +91 {profile.mobile || ""}</Text>
                        <Text style={styles.headerP}>Mail ID: {profile.email}</Text>
                    </View>
                </View>

                <View style={styles.invoiceInfo}>
                    <View style={styles.invoiceFlex}>
                        <Text style={styles.invoiceFlexHeading}>Billing To:</Text>
                        <Text style={styles.invoiceInfoText}>{invoice.customer_name}</Text>
                    </View>
                    {/* <View style={styles.invoiceFlex}>
                        <Text style={styles.invoiceFlexHeading}>Due Date:</Text>
                        <Text style={styles.invoiceInfoText}>{invoice.due_date}</Text>
                    </View> */}
                    {invoice.due_date && invoice.due_date !== "0000-00-00" && (
                        <View style={styles.invoiceFlex}>
                            <Text style={styles.invoiceFlexHeading}>Due Date:</Text>
                            <Text style={styles.invoiceInfoText}>{invoice.due_date}</Text>
                        </View>
                    )}

                </View>

                <View style={[styles.row, { backgroundColor: "#d1dffa" }]}>
                    <Text style={styles.cellFlex2}>Item</Text>
                    <Text style={styles.cell}>Qty</Text>
                    <Text style={styles.cell}>Rate</Text>
                    <Text style={styles.cell}>Discount</Text>
                    <Text style={styles.cell}>Tax</Text>
                    <Text style={styles.cell}>Amount</Text>
                </View>

                {items.map((item, i) => (
                    <View key={i} style={styles.row}>
                        <Text style={styles.cellFlex2}>{item.item?.value || "Unnamed Item"}</Text>
                        <Text style={styles.cell}>{item.quantity || "-"}</Text>
                        <Text style={styles.cell}>
                            Rs. {Number(item.rate || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                        </Text>
                        <Text style={styles.cell}>{item.discount || "0"}%</Text>
                        <Text style={styles.cell}>{item.tax || "0"}%</Text>
                        <Text style={styles.cell}>
                            Rs. {isNaN(item.amount) ? "0.00" : Number(item.amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                        </Text>
                    </View>
                ))}


                {/* Totals Breakdown */}
                <View style={{
                    borderWidth: 1,
                    borderColor: "#ccc",
                    borderRadius: 6,
                    padding: 10,
                    marginTop: 12,
                    backgroundColor: "#f2f6ff"
                }}>
                    <Text style={{
                        fontSize: 14,
                        fontWeight: "bold",
                        marginBottom: 8,
                        textAlign: "center",
                        color: "#003366"
                    }}>
                        Invoice Summary
                    </Text>

                    {[
                        { label: "Subtotal", value: invoice.subtotal },
                        // { label: "Discount Amount", value: invoice.discount_amount },
                        { label: "Advance Payment", value: invoice.advance_payment },
                        { label: "Tax", value: invoice.tax },
                        { label: "Shipping", value: invoice.shipping },
                        { label: "Pending", value: invoice.pending },
                        ...(parseFloat(invoice.subtotal) > parseFloat(invoice.advance_payment)
                            ? [{
                                label: "Discounted Amount",
                                value: parseFloat(invoice.subtotal) - parseFloat(invoice.grand_total) - parseFloat(invoice.shipping || 0)
                            }]
                            : [])
                    ].map((item, idx) => (
                        <View
                            key={idx}
                            style={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginBottom: 4,
                                borderBottomWidth: 0.5,
                                borderBottomColor: "#ddd",
                                paddingBottom: 2
                            }}
                        >
                            <Text style={{ fontSize: 12, color: "#333", fontWeight: "600" }}>{item.label}</Text>
                            <Text style={{ fontSize: 12, color: "#222" }}>Rs. {item.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</Text>
                        </View>
                    ))}
                </View>

                <View style={{
                    marginTop: 10,
                    padding: 10,
                    backgroundColor: "#003366",
                    borderRadius: 6
                }}>
                    <Text style={{
                        fontSize: 14,
                        fontWeight: "bold",
                        color: "white",
                        textAlign: "right"
                    }}>
                        Total: Rs. {invoice.grand_total.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                    </Text>
                </View>


                <View>
                    <Text style={styles.invoiceNotesHeading}>Customer Note</Text>

                    <View>
                        {renderNoteAsPDF(invoice.customer_note || '<p>No notes</p>')}
                    </View>



                </View>

                {/* <View style={styles.footer}>
                    <Text style={styles.footerPowered}>Powered by</Text>
                    <Image src={logoImgText} style={styles.footerLogo} />
                </View> */}

                <View fixed style={styles.pageFooter}>
                    <Text style={styles.footerPowered}>Powered by</Text>
                    <Image
                        src={logoImgText}
                        style={styles.footerLogo}
                    />
                    {/* <Text style={styles.footerText}>© {new Date().getFullYear()} Your Company Name</Text> */}
                </View>

            </Page>
        </Document>
    );
};

const InvoicePdf = () => {
    const { order_number } = useParams();
    const [invoiceData, setInvoiceData] = useState(null);
    const url = process.env.REACT_APP_LINK
    useEffect(() => {
        const fetchInvoice = async () => {
            try {
                const res = await fetch(`${url}/newinvoice/all`);
                const data = await res.json();
                const match = data.find(inv => String(inv.order_number) === String(order_number));
                if (match) {
                    setInvoiceData(match);
                } else {
                    alert("Invoice not found.");
                }
            } catch (error) {
                console.error("Error fetching invoice:", error);
            }
        };

        fetchInvoice();
    }, [order_number]);

    useEffect(() => {
        if (invoiceData) {
            const generate = async () => {
                const blob = await pdf(<InvoiceDocument invoice={invoiceData} />).toBlob();
                saveAs(blob, `Invoice_${invoiceData.invoice_number}.pdf`);
            };
            generate();
        }
    }, [invoiceData]);

    return null;
};
